import React, { useState, useEffect, useCallback } from 'react';
import {
  DISCORD_OPS_SETTING_KEY,
  DEFAULT_DISCORD_OPS,
  normalizeDiscordOps,
  DISCORD_OPS_SECTIONS,
} from '../utils/discordOpsSettings';

const getToken = () => localStorage.getItem('token');

function OpsRow({ field, value, onChange }) {
  return (
    <label className="settings-row" title={field.hint || undefined}>
      <span className="settings-row__label">{field.label}</span>
      <input
        type="text"
        className="settings-row__input"
        inputMode="numeric"
        placeholder="ID"
        value={value || ''}
        onChange={(e) => onChange(field.key, e.target.value)}
        onFocus={(ev) => ev.target.select()}
      />
    </label>
  );
}

export default function SettingsDiscordOps({ isActive, setError, setSuccess }) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(() => ({ ...DEFAULT_DISCORD_OPS }));

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/app-settings', {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Не удалось загрузить настройки');
      setForm(normalizeDiscordOps(data[DISCORD_OPS_SETTING_KEY] || {}));
    } catch (e) {
      setError(e.message);
      setTimeout(() => setError(''), 4000);
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    if (isActive) load();
  }, [isActive, load]);

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = normalizeDiscordOps(form);
      const res = await fetch(`/api/app-settings/${DISCORD_OPS_SETTING_KEY}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ setting_value: payload }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Не удалось сохранить');
      setForm(normalizeDiscordOps(data.setting_value || payload));
      setSuccess('Сохранено');
      setTimeout(() => setSuccess(''), 1800);
    } catch (err) {
      setError(err.message);
      setTimeout(() => setError(''), 4000);
    } finally {
      setSaving(false);
    }
  };

  if (!isActive) return null;
  if (loading) return <div className="loading">Загрузка…</div>;

  return (
    <form className="settings-panel" onSubmit={save}>
      {DISCORD_OPS_SECTIONS.map((section) => (
        <section key={section.id} className="settings-card">
          <h2 className="settings-card__title">{section.title}</h2>
          <div className="settings-rows">
            {section.fields.map((field) => (
              <OpsRow
                key={field.key}
                field={field}
                value={form[field.key]}
                onChange={setField}
              />
            ))}
          </div>
        </section>
      ))}

      <div className="settings-actions">
        <button type="button" className="settings-btn settings-btn--ghost" onClick={load} disabled={saving}>
          Отменить
        </button>
        <button type="submit" className="settings-btn settings-btn--primary" disabled={saving}>
          {saving ? '…' : 'Сохранить'}
        </button>
      </div>
    </form>
  );
}
